class Company {
  constructor(api) {
    this.api = api;
  }

  getAll(queryParams, fields, onSuccess, onError) {
    const companyUUID = localStorage.getItem("company_uuid");
    if (fields != "") {
      fields = "&include=" + fields;
    }
    let params = "";
    if (queryParams) {
      for (const [query, value] of Object.entries(queryParams)) {
        params += params === "" ? "?" : "&";
        params += query + "=" + value;
      }
    }
    return this.api.http_fibercloud
      .get("v1/companies" + params + fields, {
        headers: {
          "company-uuid": companyUUID
        }
      })
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getAllByUser(fields, onSuccess, onError) {
    if (fields != "") {
      fields = "&include=" + fields;
    }
    return this.api.http_fibercloud
      .get("v1/companiesbyuser?paginate=false" + fields)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getByID(id, fields, onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/companies/" + id + "?include=" + fields)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getByType(type, onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/companies/?paginate=false&filter[company_level_id]=" + type)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  create(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/companies", data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  edit(id, data, onSuccess, onError) {
    return this.api.http_fibercloud
      .put("v1/companies/" + id, data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  delete(id, onSuccess, onError) {
    return this.api.http_fibercloud
      .delete("v1/companies/" + id)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getAssociatedUsers(id, onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/companies/" + id + "/users?paginate=false")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getCompanyPermissionsByUserType(companyID, userType, onSuccess, onError) {
    return this.api.http_fibercloud
      .get(
        "api/companies/" + companyID + "/map-permissions?user_type=" + userType
      )
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
}

export default Company;



// WEBPACK FOOTER //
// ./src/api/company.js